import { render, staticRenderFns } from "./saveOrUpdateSysStudentIn.vue?vue&type=template&id=9b81de18&scoped=true&"
import script from "./saveOrUpdateSysStudentIn.vue?vue&type=script&lang=js&"
export * from "./saveOrUpdateSysStudentIn.vue?vue&type=script&lang=js&"
import style0 from "./saveOrUpdateSysStudentIn.vue?vue&type=style&index=0&id=9b81de18&scoped=true&lang=scss&"
import style1 from "./saveOrUpdateSysStudentIn.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b81de18",
  null
  
)

export default component.exports